import React from "react";
import PropTypes from "prop-types";
import PgHomeIndemnitySection from "./PgHomeIndemnitySection";
import PgHomeDraftsSection from "./PgHomeDraftsSection";
import IuHomeAssignmentSection from "./IuHomeAssignmentSection";
import UnpaidBondsCard from "../../../globals/components/UnpaidBondsCard";

/** Shared right-column home sections for PG / IU orchestration shells. */
export default function HomeRightColumnSections({
  sections = {},
  cfg = {},
  indemnity,
  drafts,
  assignment,
  showUnpaidBonds = false,
}) {
  return (
    <>
      {sections.assignmentAlerts && assignment && (
        <IuHomeAssignmentSection
          assignmentCopy={cfg.assignment}
          bonds={assignment.bonds}
          loadingUnassigned={assignment.loading}
        />
      )}
      {sections.indemnity && indemnity && (
        <PgHomeIndemnitySection
          indemnityCopy={cfg.indemnity}
          bonds={indemnity.bonds}
          loadingIndemnity={indemnity.loading}
          markingBondId={indemnity.markingIndemnity}
          onMarkClick={indemnity.handleMarkIndemnityClick}
        />
      )}
      {sections.drafts && drafts && (
        <PgHomeDraftsSection
          draftsCopy={cfg.drafts}
          sortedCachedBonds={drafts.sortedCachedBonds}
          cachedBondCount={Array.isArray(drafts.cachedBonds) ? drafts.cachedBonds.length : 0}
          loadingDrafts={drafts.loadingDrafts}
          deletingId={drafts.deletingId}
          onResume={(path) => window.location.assign(path)}
          onDelete={drafts.handleDeleteDraftClick}
        />
      )}
      {showUnpaidBonds ? <UnpaidBondsCard /> : null}
    </>
  );
}

HomeRightColumnSections.propTypes = {
  sections: PropTypes.object,
  cfg: PropTypes.object,
  indemnity: PropTypes.object,
  drafts: PropTypes.object,
  assignment: PropTypes.object,
  showUnpaidBonds: PropTypes.bool,
};
